import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { AddGeoDistace, getConfigStatus, getGeoDistaceList, getTownList, updateGeoDistance} from "./useGeoDistance"
import {toast} from "react-toastify"
import { showToast } from "../../../../utils/toastUtils"


interface paramInterface{
    start?:number,
    length?:number,
    search?:string,
    sortColumn?:string |null ,
    sortOrder?:string | null
    CalculationType?:string | null,
    FromTownId?:number | null
    ToTownId?:number | null
}

export const useGetGeoDistanceList =({enable = false,params={}}:{enable:boolean,params:paramInterface})=>{
    return useQuery({
        queryKey:['GET_GEO_DISTANCE',params],
        queryFn:()=>getGeoDistaceList(params),
        enabled:enable,
        retry:false
    })
}

    interface ReqBodyInterface {
    BeltName?: string | undefined;
    FromStateId: number | null;
    FromTownId: number | null;
    ToStateId: number | null;
    ToTownId: number | null;
    CalculationType: string;
    DistanceKm: number | null;
    Amount: number | null;
    Remark: string;
    TravelDocNeeded: string;
    }

    export const useAddGeoDistace = ()=>{
        const queryClient = useQueryClient();

        return useMutation({
            mutationFn:(ReqBody:ReqBodyInterface)=>AddGeoDistace(ReqBody),
        
        onSuccess:()=>{
            showToast.success('Add Geo Distance successfully');
            queryClient.invalidateQueries({queryKey:['GET_GEO_DISTANCE']});
        },
        onError:(error:any)=>{
                  console.error("Failed to update:", error.message)    
                  showToast.error("Failed to Add GeoDistance. Please try again.");       
        }
    },)
}

export const useUpdateGeoDistannce=()=>{
    const queryClient = useQueryClient();
    return useMutation({

        mutationFn:({ReqBody,id}:{ReqBody:ReqBodyInterface,id:number})=>updateGeoDistance(ReqBody,id),
        onSuccess:()=>{
         showToast.success('Updated Successfully');
         queryClient.invalidateQueries({queryKey:['GET_GEO_DISTANCE']})
        },
        onError:(error:any)=>{
          showToast.error('Failed to Update');
          console.log('Failed to Update',error.message);
        }
    })
}


export const useGetTownList = ({enabled=false,param}:{enabled:boolean,param:Record<string,any>})=>{
   return  useQuery({
    queryKey:['GET_TOWN_LIST',param],
    queryFn:()=>getTownList(param),
    retry:false,
    enabled:true,
   })
}

export const useGetConfigStatus =({enable=false})=>{
  return useQuery({
    queryKey:['GET_CONFIG_STATUS'],
    queryFn:getConfigStatus,
    enabled:enable,
   retry:false,
  })
}
